import React, { Component } from 'react';
import Grid from 'material-ui/Grid';
import ThumbUpIcon from 'material-ui-icons/ThumbUp';
import ThumbDownIcon from 'material-ui-icons/ThumbDown';
import Button from 'material-ui/Button';
import { db } from '../ThirdPartyIntegration/firebaseClient'
import { config } from '../config';

class Search extends Component {
    // have they both rated each other?
    // have they both rated each other the same?

    /**
     * user/rated = {
     *  userId: {
     *      ratedOn: date,
     *      rating: +1
     * }, 
     *  userId: {
     *      ratedOn: date,
     *      rating: -1
     * }
     * 
     * user/receivedRatings = {
     *  userId: {
     *      ratedOn: date,
     *      rating: +1
     * }, 
     *  userId: {
     *      ratedOn: date,
     *      rating: -1
     * }
     * 
     * A match is when a receivedRating is +1 and rated is +1
     * When a user is rated we must update the rater, and the ratee in a background function.
     * Send a push notification to the ratee that they have a new match.
     * show notification bubbles for both.
     * If they have both rated each other +1 we should add them to matches.
     * user/matches = {
     *  userId: {
     *      matchedOn: date,
     *      conversation: conversationId
     *  },
     *  userId: {
     *      matchedOn: date,
     *      conversation: conversationId
     *  }
     * }
     * 
     * to show notifications of new matches
     * should also do a push notification.
     * user/notifications = {
     *      newMatches: 0
     * }
     */

    constructor() {
        super();

        let userJsonString = window.localStorage.getItem(config.localstorage.userKey);
        let user = JSON.parse(userJsonString);
        this.state = { user: user };

        // let's load up some userids, and images.
        let ref = db.ref('/users');
        ref.orderByChild('info/lastLoggedInOn').once('value')
            .then((snapshot) => {
                let potentialDates = []

                let addToPotentialDate = (user) => {
                    if (user.picture) {
                        var date = {
                            uid: user.uid,
                            picture: user.picture
                        };
                        potentialDates.push(date);
                    }
                }

                snapshot.forEach((user) => {
                    let otherUser = user.child('info').val();

                    // filter out logged in user.
                    if (otherUser.uid !== this.state.user.uid) {
                        // TODO: filter out people that have been rated before.

                        // only show people based on gender and orientation
                        if (this.state.user.isGay
                            && otherUser.isGay
                            && otherUser.gender === this.state.user.gender) {
                                // console.log('i am gay, they are gay, and genders are the same');
                                addToPotentialDate(user);
                        } else if (!this.state.user.isGay
                            && !otherUser.isGay
                            && otherUser.gender !== this.state.user.gender) {
                                // console.log('i am NOT gay, they are NOT gay, and genders are NOT the same');
                                addToPotentialDate(otherUser)
                        }
                    }
                });
                this.setState({ potentialDates: potentialDates, index: 1, date: potentialDates[0] });
            });

        this.onClickRate = this.onClickRate.bind(this);
    }

    onClickRate(rating, userId) {
        this.nextDate();
        db.ref(`/users/${this.state.user.uid}/rated/${userId}`).set({
            ratedOn: Date.now(),
            rating: rating
        });
    }

    nextDate() {
        let index = this.state.index;
        if (index < this.state.potentialDates.length) {
            let nextDate = this.state.potentialDates[index];
            index++;
            this.setState({
                date: nextDate,
                index: index
            })
        } else {
            // TODO: what to do when out of dates?
            console.log('out of dates');
        }
    }

    render() {
        const centerStyle = {
            textAlign: 'center'
        }

        let picture = 'https://placeimg.com/412/480/people';
        let userId = null;
        if (this.state.date) {
            picture = this.state.date.picture;
            userId = this.state.date.uid;
        }

        return (
            <Grid container spacing={24}>
                <Grid item xs={12} style={centerStyle}>
                    <img src={picture} alt="potential" />
                </Grid>
                <Grid item xs={12}>
                    <Grid container>
                        <Grid item xs={6} style={{ textAlign: 'right' }}>
                            <Button raised onClick={() => { this.onClickRate(-1, userId) }}>
                                <ThumbDownIcon />
                            </Button>
                        </Grid>
                        <Grid item xs={6} style={{ textAlign: 'left' }}>
                            <Button raised color='accent' onClick={() => { this.onClickRate(+1, userId) }}>
                                <ThumbUpIcon />
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        )
    }
}

export default Search;


// WEBPACK FOOTER //
// ./src/Components/Search.jsx